export default [
  `$ npm i vue-api-request --save`,
  `$ yarn add vue-api-request`,
  `<script src="https://unpkg.com/vue-api-request@latest/dist/vue-api-request.min.js"></script>
<link href="https://unpkg.com/vue-api-request@latest/dist/vue-api-request.min.css" rel="stylesheet"/>
`
]




// WEBPACK FOOTER //
// ./src/codes/VueApiRequestDemo/Installation.js